import { lazy } from 'react';
/** Открывает форму адреса клиента */
export const ClientAddressFormPageAsync = lazy(() => import('./ClientAddressForm/ClientAddressFormPage'));